export default "__VITE_ASSET__Br6Ltueu__"